import { Helmet } from 'react-helmet-async';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Weight } from "lucide-react";
import { Link } from "react-router-dom";
const WeightManagement = () => {
  return <>
      <Helmet>
        <title>Weight Loss & Management Services | Functional Foodie</title>
        <meta name="description" content="Professional weight loss and management services in Johannesburg. Sustainable plans tailored to your lifestyle. Get started with Functional Foodie today." />
      </Helmet>
      <section id="weight-management" className="py-16">
        <div className="container mx-auto px-4">
          <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 bg-[#fedd7d]/20">
            <CardHeader className="flex flex-row items-center gap-4">
              <div className="p-4 rounded-full bg-[#fedd7d]/50">
                <Weight className="w-8 h-8 text-[#85a3a6]" />
              </div>
              <CardTitle className="text-xl font-semibold text-primary">
                Weight Loss Management
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">
                <p className="text-gray-600 leading-relaxed">
                  We can assist by assessing your dietary needs, body fat percentage, muscle mass and design a meal plan in order to reach these goals- with it still fitting into your current lifestyle.
                </p>
                
                <h3 className="text-lg font-semibold text-primary mt-8">Sustainable Weight Management</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our approach to weight management focuses on sustainable, lifestyle changes rather than quick fixes. We help you develop healthy eating habits that fit your lifestyle and preferences.
                </p>
                
                <h3 className="text-lg font-semibold text-primary">Our Process</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Comprehensive body composition assessment</li>
                  <li>Analysis of eating patterns and habits</li>
                  <li>Personalised meal plans that fit your schedule</li>
                  <li>Realistic goal setting</li>
                  <li>Regular follow-ups to track progress</li>
                  <li>Adjustments based on your results and feedback</li>
                </ul>
                
                <h3 className="text-lg font-semibold text-primary">Benefits of Our Approach</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our clients experience not just weight loss, but improved energy levels, better sleep, enhanced mood, and overall improved health markers such as cholesterol levels and blood pressure.
                </p>
                
                <div className="mt-8 flex justify-center">
                  <Link to="/booking">
                    <Button size="lg" className="bg-primary hover:bg-primary-light text-white px-8">
                      Book a Consultation
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </>;
};
export default WeightManagement;